'use client';

import type {FC} from 'react';
import {useLiveQuery} from 'next-sanity/preview';
import {internalLinkToHref} from 'utils';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {LinkSchema} from 'components/inline-link/schema';

import {InlineLinkRender} from './render';

interface Props {
	inlineLink: LinkSchema & {text: string};
	className?: string;
}

export const InlineLinkDraft: FC<Props> = ({inlineLink, className}) => {
	const [reference, loading] = useLiveQuery<LinkReferencesQueryResult>(
		null,
		LINK_REFERENCES_QUERY,
		{
			id: inlineLink.reference?._ref ?? '',
		},
	);

	if (loading) {
		return (
			<InlineLinkRender
				targetBlank={inlineLink.targetBlank}
				text={inlineLink.text}
				className={className}
			/>
		);
	}

	return (
		<InlineLinkRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={inlineLink.targetBlank}
			text={inlineLink.text}
			className={className}
		/>
	);
};
